export default __webpack_public_path__ + "static/media/Screenshot_10.2065e584.png";